import { svg } from "lit";
const icon = svg `<path d="M9.2695 14.5695V38.7305H38.7305V14.5695H31V30.15L24 26.65L17 30.15V14.5695H9.2695ZM7 41V12.6845L11.35 7H36.6L41 12.723V41H7ZM10.081 12.3H37.85L35.4155 9.2695H12.5345L10.081 12.3ZM19.2695 14.5695V26.473L24 24.1075L28.7305 26.473V14.5695H19.2695Z" fill="currentColor"/>`;
export default icon;
